import { render, staticRenderFns } from "./FaqPage.htm?vue&type=template&id=1f8dd7ba&scoped=true&external"
import script from "./FaqPage.js?vue&type=script&lang=js&external"
export * from "./FaqPage.js?vue&type=script&lang=js&external"
import style0 from "./FaqPage.scss?vue&type=style&index=0&id=1f8dd7ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8dd7ba",
  null
  
)

export default component.exports